<template>
    <div>
        <!--begin::Label-->
        <label class="form-label fs-6 fw-bolder  text-dark"
               :class="item.is_required ? 'required' : ''"
        >
            <slot v-if="i18n.locale.value == 'ar'">
                {{item.label_ar}}
            </slot>
            <slot v-if="i18n.locale.value == 'en'">
                {{item.label}}
            </slot>
            <slot v-if="!item.is_required">&nbsp;{{$t('optional')}}</slot>
        </label>
        <!--end::Label-->

        <div>
            <el-select
                    :name='item.model_key + item.key' filterable class="w-100"
                    v-model="item.value"
                    :rules="$helpers.getValidationRules(item)"
                    :clearable="true"
                    :disabled="item.hasOwnProperty('is_editable') && !item.is_editable"
                    :placeholder="$t('choose')">
                <el-option
                        v-for="(selection,key) in fillSelectOptions(item,items)"
                        :value="selection.id"
                        :label="i18n.locale.value == 'ar' ? selection.value_ar : selection.value"/>
            </el-select>
            <Field v-model="item.value" :name='item.model_key + item.key' :rules="$helpers.getValidationRules(item)"
                   type="hidden"
                   :label="i18n.locale.value == 'ar' ? item.label_ar : item.label"
                   v-slot='{ field }'>
            </Field>

            <!--<Field v-model="item.value"-->
            <!--:label="i18n.locale.value == 'ar' ? item.label_ar : item.label"-->
            <!--:name=' item.model_key + item.key'-->
            <!--:rules="$helpers.getValidationRules(item)"-->
            <!--type="hidden"-->
            <!--class="d-none"/>-->
        </div>

        <div class="fv-plugins-message-container">
            <div class="fv-help-block">
                <!--<span class="text-dark">({{item.type}})</span>-->
                <slot v-if="i18n.locale.value == 'ar'">
                    <span class="text-muted">{{item.hint_text_ar}}</span>
                </slot>
                <slot v-if="i18n.locale.value == 'en'">
                    <span class="text-muted">{{item.hint_text_en}}</span>
                </slot>
            </div>
        </div>

        <div class="fv-plugins-message-container">
            <div class="fv-help-block">
                <!--<ErrorMessage :name="item.model_key + item.key"/>-->
                <ErrorMessage :name="item.model_key + item.key" v-slot="{ message }">
                    <template v-if="item.validation_error_msg_ar  && i18n.locale.value == 'ar'">
                        <slot>
                            {{item.validation_error_msg_ar}}
                        </slot>
                    </template>
                    <template v-if="item.validation_error_msg  && i18n.locale.value == 'en'">
                        <slot>
                            {{item.validation_error_msg}}
                        </slot>
                    </template>
                    <template
                            v-if="!(item.validation_error_msg_ar  && i18n.locale.value == 'ar')  && !(item.validation_error_msg  && i18n.locale.value == 'en')">
                        <slot>
                            {{message}}
                        </slot>
                    </template>
                </ErrorMessage>
            </div>
        </div>
    </div>
</template>

<script lang="ts">
  import {
    defineComponent,
    watch,
    reactive,
    toRefs,
    inject,
    defineAsyncComponent,
    onMounted,
    nextTick,
  } from 'vue';
  import { useStore } from 'vuex';
  import { useRouter, useRoute } from 'vue-router';
  import { useI18n } from 'vue-i18n';
  import * as _ from 'lodash';
  import { ErrorMessage, Field, Form } from 'vee-validate';

  export default defineComponent({
    name: 'RecirsoveSelect',
    components: {
      Field,
      ErrorMessage,
    },
    props: ['item', 'items', 'iterator'],
    setup(props, context) {
      const helpers: any = inject('helpers');
      const i18n = useI18n();
      const store = useStore();

      const state = reactive({
        item: props.item,
        items: props.items,
        iterator: props.iterator,
      });

      onMounted(() => {
        // console.log(JSON.parse(JSON.stringify(props.items)))

        if (!state.item.value) {
          triggerChange(null);
        }
      });

      watch(
        () => state.item.value,
        (item, prevCount) => {
          triggerChange(item);
        },
      );

      const fillSelectOptions = (item, items) => {
        if (!item.parent_model_key) {
          return item.selection_values;
        }

        let parent_model_item = _.find(items, (i) => {
          return i.model_key == item.parent_model_key;
        });
        if (parent_model_item && parent_model_item.value) {
          return getStaticSelectionData(parent_model_item.value);
        }

      };

      const triggerChange = (selection = null) => {
        let item: any = state.item;
        let iterator: any = state.iterator;
        let selected_value: any = getSelectValue(item, selection);

        // remove parent_model_key from items

         _.forEach(state.items,(i)=>{
            if(i.parent_model_key == item.model_key){
              i.value = null
            }
        })

        // remove item
        let removalKeys: any = [];
        if (selected_value) {
          _.forEach(item.selection_values, (SV) => {
            let SECTION: any = SV?.section;
            // console.log(SECTION)
            if (SECTION && SV.id != selected_value.id) {
              removalKeys.push(SECTION?.model_key);
            }
          });
        } else {
          _.forEach(item.selection_values, (SV) => {
            let SECTION: any = SV?.section;
            if (SECTION) {
              removalKeys.push(SECTION?.model_key);
            }
          });
        }
        _.remove(state.items, function(currentObject: any) {
          return removalKeys.includes(currentObject.model_key);
        });

        if (selected_value && selected_value.section) {
          setTimeout(() => {
            state.items.splice(iterator + 1, 0, cloneSection(selected_value.section));
          }, 100);
        }
      };

      const cloneSection = (section) => {
        let clonedSectionItem: any = Object.assign({}, section);
        clonedSectionItem.key = `_main_${Math.random().toString(16)}`;
        clonedSectionItem.section_repeat_index = 1;

        let itemsR: any = [];
        _.forEach(clonedSectionItem.items, (oldItem) => {
          // oldItem = JSON.parse(JSON.stringify(oldItem));
          oldItem.key = `_sub_${Math.random().toString(16)}`;
          oldItem.value = null;
          oldItem.values = [];
          itemsR.push(oldItem);
        });
        return clonedSectionItem;
      };

      const getSelectValue = (item, val) => {
        let Gitem: any = null;
        _.forEach(item.selection_values, (_item) => {
          if (_item.id == val) {
            Gitem = _item;
            return;
          }
        });
        return Gitem;
      };

      let data = store.getters['moduleCommon/getLookups'];

      const getStaticSelectionData = (KEY) => {
        let ST:any = store.getters['moduleCommon/getLookups'];

        // let ST: any = {
        //   'GIZ-1': [
        //     {
        //       'id': 'GIZ-FAC-1',
        //       'value': 'GIZA Faculty 1',
        //       'value_ar': 'GIZA Faculty 1',
        //     },
        //     {
        //       'id': 'GIZ-FAC-2',
        //       'value': 'GIZA Faculty 2',
        //       'value_ar': 'GIZA Faculty 2',
        //     },
        //     {
        //       'id': 'GIZ-FAC-3',
        //       'value': 'GIZA Faculty 3',
        //       'value_ar': 'GIZA Faculty 3',
        //     },
        //   ],
        //   'CAI-1': [
        //     {
        //       'id': 'CAI-FAC-1',
        //       'value': 'CAIRO Faculty 1',
        //       'value_ar': 'CAIRO Faculty 1',
        //     },
        //     {
        //       'id': 'CAI-FAC-2',
        //       'value': 'CAIRO Faculty 2',
        //       'value_ar': 'CAIRO Faculty 2',
        //     },
        //     {
        //       'id': 'CAI-FAC-3',
        //       'value': 'CAIRO Faculty 3',
        //       'value_ar': 'CAIRO Faculty 3',
        //     },
        //   ],
        //   'MEN-1': [
        //     {
        //       'id': 'MEN-FAC-1',
        //       'value': 'MENOUFIA Faculty 1',
        //       'value_ar': 'MENOUFIA Faculty 1',
        //     },
        //     {
        //       'id': 'MEN-FAC-2',
        //       'value': 'MENOUFIA Faculty 2',
        //       'value_ar': 'MENOUFIA Faculty 2',
        //     },
        //     {
        //       'id': 'MEN-FAC-3',
        //       'value': 'MENOUFIA Faculty 3',
        //       'value_ar': 'MENOUFIA Faculty 3',
        //     },
        //   ],
        // };

        if (ST[KEY]) {
          return ST[KEY];
        }
        return [];
      };

      return {
        ...toRefs(state),
        i18n,
        triggerChange,
        helpers,
        getSelectValue,
        fillSelectOptions,
      };
    },
  });
</script>
